import { Badge, Col, Container, Row } from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import './styles.css';
import PropertyCard from "../../components/Cards/PropertyCard";
import { API_URL, STORAGE_URL } from "../../utils/constants";
import { useEffect, useState } from "react";
import HomeSearchForm from "./Forms/Search";
import { Link, useLocation } from "react-router-dom";
import DefaultButton from "../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import BannerCarousel from "./Slider";
import FullscreenAd from "./Modals/ads";

function HomePage() {
  const { t } = useTranslation();
  const location = useLocation();
  const [propertiesLoading, setPropertiesLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]);
  const [properties, setProperties] = useState([]);
  const [banners, setBanners] = useState([]);
  const [contentAds, setContentAds] = useState(null);
  const [fullscreenAds, setFullscreenAds] = useState(null);

  const getHomeData = () => {
    const cacheKey = `home_data_${location.search}`;
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      const parsed = JSON.parse(cachedData);
      setCategories(parsed.categories);
      setStates(parsed.states);
      setProperties(parsed.properties);
      setBanners(parsed.banners || []);
      setContentAds(parsed.contentAds || null);
      const adSeen = sessionStorage.getItem('fullscreen_ad_seen');
      setFullscreenAds(!adSeen ? (parsed.fullscreenAds || null) : null);
      setPropertiesLoading(false);
      return;
    }

    setPropertiesLoading(true);
    fetch(API_URL + '/home', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setCategories(data.categories);
        setStates(data.states);
        setProperties(data.properties);
        setContentAds(data.content_ads || null);
        const adSeen = sessionStorage.getItem('fullscreen_ad_seen');
        setFullscreenAds(!adSeen ? (data.fullscreen_ads || null) : null);
        setBanners(data.banners);
        sessionStorage.setItem(cacheKey, JSON.stringify({
          categories: data.categories,
          states: data.states,
          properties: data.properties,
          contentAds: data.content_ads || null,
          fullscreenAds: data.fullscreen_ads || null,
          banners: data.banners
        }));
      }
      setPropertiesLoading(false);
    })
    .catch(error => {
      console.error('Error fetching home data:', error);
      setPropertiesLoading(false);
    });
  }

  useEffect(() => {
    getHomeData();
  }, [location.search]);

  return (
    <MainLayout>
      <section className="home-slider">
        <Row className="justify-content-center mx-0">
          <Col lg="5" md="8" className="px-0">      
            <BannerCarousel banners={banners} />
          </Col>
        </Row>
      </section>

      <section className="section-search">
        <Container>
          <HomeSearchForm
            categories={categories}
            states={states}
          />
        </Container>
      </section>
      <section className="mb-5">
        <Container>
          <h2 className="mb-3 text-center">{t('home.sections.last_ads.title')}</h2>
          {propertiesLoading ? (
            <div className="loader-container">
              <div className="loader"></div>
            </div>
          ) : (
            <Row className="justify-content-center">
              {contentAds && (
                <Col md="8">
                  <div className='property-card-container border mb-3 position-relative premium' style={{backgroundColor: '#e2e2e2'}}>
                    <Link 
                      to={'/banner/' + contentAds.id} 
                      className="stretched-link" 
                      state={{ banner: contentAds }}
                    ></Link>
                    <Badge 
                      color="secondary" 
                      className="position-absolute top-0 end-0 m-2 fw-light rounded-pill px-2 py-1"
                    >
                      ADS
                    </Badge>
                    <Row>
                      <Col lg="2" md="3" xs="3">
                        <img src={STORAGE_URL + contentAds.image_url} width={'100%'} alt="" />
                      </Col>
                      <Col lg="10" md="9" xs="9" className="ps-2 pe-3">
                        <h5 className="mt-3">{ contentAds.title }</h5>
                      </Col>
                    </Row>
                  </div>
                </Col>
              )}
              {properties?.map((data, key) => {
                return (
                  <Col lg="8" key={key}>
                    <PropertyCard property={data} />
                  </Col>
                );
              })}
              <Col md="8" className="mb-5">
                <Link to="/search">
                  <DefaultButton outline block size="lg" className="rounded-pill">
                    {t('home.sections.last_ads.view_more')}
                  </DefaultButton>
                </Link>
              </Col>
            </Row>
          )}
        </Container>
      </section>

      <FullscreenAd 
        ad={fullscreenAds}
        isOpen={!!fullscreenAds}
        onClose={() => { sessionStorage.setItem('fullscreen_ad_seen', '1'); setFullscreenAds(null); }}
      />
    </MainLayout>
  );
}

export default HomePage;
